import script from "./PlanosEventoList.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanosEventoList.vue?vue&type=script&setup=true&lang=js"

import "./PlanosEventoList.vue?vue&type=style&index=0&id=2739f288&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2739f288"]])

export default __exports__